import { VFC } from "react";
import { Box, Grid, Typography } from "@mui/material";

type Props = {
  label: string;
  xs?: number;
  align?: "right" | "left" | "center" | "inherit" | "justify" | undefined;
  isMandatory?: boolean;
};
export const FormLabel: VFC<Props> = ({ label, xs = 2, align="right", isMandatory=false }) => {
  return (
    <Grid item xs={xs}>
      <Typography component="span" align={align} display={"block"} noWrap>
        <Typography component="span" display={"inline"} noWrap>
          {label}
        </Typography>
        <Typography component="span" display={"inline"} noWrap color={"red"}>
          {isMandatory && "*"}
        </Typography>
      </Typography>
    </Grid>
  );
};
